import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ReviewsPage } from "@/features/growthpeople/ReviewsPage";

const search = z.object({
  status: z.enum(["all", "planned", "active", "closed"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/reviews/")({
  validateSearch: search,
  component: () => <ReviewsPage search={Route.useSearch()} />,
});
